export const SourcetreeLogoInverse = () => (
  <svg
    width="257"
    height="48"
    viewBox="0 0 257 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56.199 39.4223C50.356 39.4223 47.642 38.2723 45.296 37.0763V32.8443C48.103 34.3163 52.427 35.3743 56.429 35.3743C60.984 35.3743 62.686 33.5803 62.686 30.9123C62.686 28.2443 61.03 26.8173 55.279 25.4373C48.47 23.7813 45.434 21.4353 45.434 16.4663C45.434 11.7743 49.022 8.27734 56.061 8.27734C60.432 8.27734 63.238 9.33534 65.308 10.4853V14.6253C62.272 12.8773 59.005 12.3253 55.877 12.3253C51.92 12.3253 49.574 13.7053 49.574 16.4663C49.574 18.9503 51.506 20.1933 56.843 21.5273C63.238 23.1373 66.826 25.2083 66.826 30.6363C66.826 35.8813 63.698 39.4233 56.199 39.4233V39.4223Z"
      fill="white"
    />
    <path
      d="M70.319 27.4155C70.319 20.5145 74.367 15.4995 81.268 15.4995C88.122 15.4995 92.125 20.5145 92.125 27.4155C92.125 34.3165 88.123 39.4225 81.268 39.4225C74.367 39.4225 70.319 34.3165 70.319 27.4155ZM74.183 27.4155C74.183 31.7865 76.345 35.7425 81.268 35.7425C86.144 35.7425 88.261 31.7855 88.261 27.4155C88.261 23.0455 86.145 19.1805 81.268 19.1805C76.345 19.1805 74.183 23.0445 74.183 27.4155Z"
      fill="white"
    />
    <path
      d="M96.263 15.9595H100.22V29.8535C100.22 33.9935 101.876 35.8335 105.649 35.8335C109.329 35.8335 111.859 33.3955 111.859 28.7485V15.9595H115.816V38.9615H111.859V35.1895C110.387 37.9035 107.672 39.4215 104.59 39.4215C99.299 39.4215 96.263 35.7875 96.263 29.4385V15.9595Z"
      fill="white"
    />
    <path
      d="M125.658 38.9624H121.793V15.9594H125.658V20.0074C126.992 17.2934 129.292 15.3614 133.801 15.6364V19.5004C128.74 18.9944 125.658 20.5124 125.658 25.3894V38.9614V38.9624Z"
      fill="white"
    />
    <path
      d="M152.982 38.3645C151.602 39.1005 149.486 39.4225 147.37 39.4225C139.181 39.4225 135.363 34.4545 135.363 27.4155C135.363 20.4685 139.181 15.4995 147.37 15.4995C149.44 15.4995 151.05 15.7755 152.845 16.6035V20.2835C151.373 19.5935 149.808 19.1795 147.646 19.1795C141.666 19.1795 139.227 22.9515 139.227 27.4145C139.227 31.8775 141.711 35.6495 147.738 35.6495C150.084 35.6495 151.556 35.3275 152.982 34.8215V38.3635V38.3645Z"
      fill="white"
    />
    <path
      d="M168.483 39.4225C159.88 39.4225 156.108 34.4545 156.108 27.4155C156.108 20.4685 159.972 15.4995 166.965 15.4995C174.05 15.4995 176.903 20.4225 176.903 27.4155V29.2095H160.111C160.663 33.1195 163.193 35.6495 168.622 35.6495C171.29 35.6495 173.545 35.1435 175.615 34.4075V38.0425C173.729 39.0545 170.831 39.4225 168.484 39.4225H168.483ZM160.064 25.8045H172.9C172.67 21.5265 170.737 19.0885 166.781 19.0885C162.594 19.0885 160.478 21.8025 160.064 25.8045Z"
      fill="white"
    />
    <path
      d="M190.701 35.2355C191.621 35.2355 192.495 35.0515 193.185 34.9135V38.7315C192.495 38.9155 191.713 39.0995 190.517 39.0995C185.594 39.0995 183.202 36.2015 183.202 31.9225V19.6385H179.475V15.9585H183.202V11.0815H187.066V15.9585H193.185V19.6385H187.066V31.8295C187.066 33.8535 188.262 35.2335 190.701 35.2335V35.2355Z"
      fill="white"
    />
    <path
      d="M202.108 38.9624H198.243V15.9594H202.108V20.0074C203.442 17.2934 205.742 15.3614 210.251 15.6364V19.5004C205.19 18.9944 202.108 20.5124 202.108 25.3894V38.9614V38.9624Z"
      fill="white"
    />
    <path
      d="M224.188 39.4225C215.585 39.4225 211.813 34.4545 211.813 27.4155C211.813 20.4685 215.677 15.4995 222.67 15.4995C229.755 15.4995 232.608 20.4225 232.608 27.4155V29.2095H215.816C216.368 33.1195 218.898 35.6495 224.327 35.6495C226.995 35.6495 229.25 35.1435 231.32 34.4075V38.0425C229.434 39.0545 226.536 39.4225 224.189 39.4225H224.188ZM215.769 25.8045H228.605C228.375 21.5265 226.442 19.0885 222.486 19.0885C218.299 19.0885 216.183 21.8025 215.769 25.8045Z"
      fill="white"
    />
    <path
      d="M248.292 39.4225C239.689 39.4225 235.917 34.4545 235.917 27.4155C235.917 20.4685 239.781 15.4995 246.774 15.4995C253.859 15.4995 256.712 20.4225 256.712 27.4155V29.2095H239.92C240.472 33.1195 243.002 35.6495 248.431 35.6495C251.099 35.6495 253.354 35.1435 255.424 34.4075V38.0425C253.538 39.0545 250.64 39.4225 248.293 39.4225H248.292ZM239.873 25.8045H252.709C252.479 21.5265 250.546 19.0885 246.59 19.0885C242.403 19.0885 240.287 21.8025 239.873 25.8045Z"
      fill="white"
    />
    <path
      d="M19.457 29.5723C19.457 27.0363 17.401 24.9803 14.865 24.9803C12.09 24.9803 9.84 22.7303 9.84 19.9553C9.84 17.1803 12.09 14.9303 14.865 14.9303C15.206 14.9303 15.538 14.9653 15.86 15.0293V5.12733C15.531 5.10533 15.2 5.09033 14.865 5.09033C6.655 5.09033 0 11.7453 0 19.9553C0 26.5613 4.312 32.1533 10.272 34.0893V41.5563C10.272 42.1333 10.74 42.6013 11.317 42.6013H18.411C18.988 42.6013 19.456 42.1333 19.456 41.5563V29.5723H19.457Z"
      fill="white"
    />
    <path
      d="M14.865 5.09033V14.9303C17.64 14.9303 19.89 17.1803 19.89 19.9553C19.89 22.7303 17.64 24.9803 14.865 24.9803C17.401 24.9803 19.457 27.0363 19.457 29.5723V34.0933C25.418 32.1583 29.73 26.5613 29.73 19.9553C29.73 11.7453 23.075 5.09033 14.865 5.09033Z"
      fill="url(#paint0_linear_2317_23459)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2317_23459"
        x1="22.297"
        y1="31.4103"
        x2="22.297"
        y2="15.6153"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
